module.exports = __webpack_public_path__ + "static/fonts/Oswald-Light.0e85aec.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Light.ttf
// module id = /ZT6
// module chunks = 1